import WhatsApp from '../../src/legacy/WhatsApp.tsx';
export default WhatsApp;
